import { H3, LI, UL } from '../../../../AbstractElements'
import { CardType } from '../../../../Type/Application/Users/UsersProfile'
import { Followers, Following, Posts } from '../../../../utils/Constant'

const UserCardsFooter :React.FC<CardType> = ({ item }) => {
  return (
    <UL className="social-follow flex-row simple-list">
      <LI>
        <H3>{item.totalPost}</H3>
        <span className="f-light">{Posts}</span>
      </LI>
      <LI>
        <H3>{item.follower}</H3>
        <span className="f-light">{Followers}</span>
      </LI>
      <LI>
        <H3>{item.following}</H3>
        <span className="f-light">{Following}</span>
      </LI>
    </UL>
  )
}

export default UserCardsFooter